import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { RouteNames } from '../../../constans/routes';
import InformationText from '../../InformationText/InformationText';
import Notification from '../../Notification/Notification';
import ResetPassword from '../ResetPassword';
import { Headline, HeadlineBold } from '../ResetPassword.styles';
import { Container, InformationTextCont } from './ResetPasswordConfirm.styles';
import BackIcon from '@/assets/icons/backIcon.svg?react';

const ResetPasswordConfirm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const message = {
    mode: 'information',
    type: 'static',
    title: t('login.resetPassword.passwordLink'),
    description: t('login.resetPassword.linkExpirationText'),
  };

  const headline = (
    <Headline>
      <HeadlineBold>{t('login.resetPassword.password')}&nbsp;</HeadlineBold>
      {t('login.resetPassword.resetSent')}
    </Headline>
  );

  const resetPasswordConfirm = (
    <Container>
      <InformationTextCont>
        <InformationText text={t('login.resetPassword.emailSentConfirmText')} />
        <InformationText text={t('login.resetPassword.emailNotReceivedText')} />
      </InformationTextCont>
      <Notification data={message} />
    </Container>
  );

  return (
    <ResetPassword
      headline={headline}
      content={resetPasswordConfirm}
      submit={() => navigate(RouteNames.Login)}
      buttonText={t('login.resetPassword.goBack')}
      buttonIcon={<BackIcon />}
    />
  );
};

export default ResetPasswordConfirm;
